import "./inc/retail_user.js";
import { Fancybox, Panzoom } from "@fancyapps/ui";
import * as bootstrap from "bootstrap";

// oilib.js needs bootstrap to be available on the window object. It uses bootstrap popovers (maybe others, too).
window.bootstrap = bootstrap;

// ========================
// == Trigger Tabs By Hash
var triggerTabList = [].slice.call(document.querySelectorAll(".tab-btn"));

triggerTabList.forEach(function (triggerEl) {
  var tabTrigger = new bootstrap.Tab(triggerEl);
  var hash = '#' + triggerEl.href.split("#")[1];
  var tabBtn = document.querySelector( hash + "-tab");

  triggerEl.addEventListener("click", function (event) {
    event.preventDefault();
    tabBtn.click();
  })
})
// END Trigger Tabs By Hash
// ========================

// ========================
// == Add class to main navbar on scroll

window.onload = function () { checkNavScroll() };
window.onscroll = function () { checkNavScroll() };

let header = document.getElementById("site-nav");
let onScroll = 25;
if (typeof alwaysScrolled === 'undefined') {
    var alwaysScrolled = false;
}

function checkNavScroll() {
    if (window.pageYOffset > onScroll || alwaysScrolled == true) {
        header.classList.add("scrolled");
    } else {
        header.classList.remove("scrolled");
    }
}

// END scrolled
// ========================

// ========================
// == Panzoom =============

const panzoom = document.querySelector(".panzoom");
const panzoom_reset = document.querySelector(".panzoom-reset");
const panZoomImg = document.querySelector('.panzoom__content');
const fpImgLink = document.querySelectorAll("[data-imgurl]");

if (panzoom) {
    const myPanzoom = new Panzoom(panzoom, {
        minScale:0.5,
        maxScale:3,
    });
    panzoom_reset.addEventListener("click", function (event) {
        myPanzoom.zoomTo(1);
    })
}

for (const link of fpImgLink) {
    link.addEventListener('click', function () {
        fpImgLink.forEach((e)=> {e.classList.remove('active-bg')})
        link.classList.add('active-bg');
        var imgUrl = link.dataset.imgurl;
        panZoomImg.src = imgUrl;
    });
}

// END Panzoom ============
// ========================

/*
 * FANCYBOX
 *
 * The new Fancybox v4 (non-jQuery) triggers a "done" event for up to three images when
 * the carousel is first initilaized. To avoid triggering 3 image view events on every
 * Fancybox initCarousel action, an imageview event is triggered on the initCarousel
 * event, but "done" events are then ignored for 1 second. After 1 second, image view
 * events will be triggered as typical.
 */

// Tracks fancybox image views.
let fancyboxEventBlock = false

/** Abstracted event action handler
 * @param {import("@fancyapps/ui").Fancybox} fancybox
 */
const doFancyboxOiEvent = (fancybox) => {
    if (fancybox.options.trigger.dataset.oiEventName) {
        let oi_event_name = fancybox.options.trigger.dataset.oiEventName;
        if ("undefined" != typeof window.dataLayer) {
            window.dataLayer.push({ event: oi_event_name });
        }
        if ("undefined" != typeof window.hfaDataLayer) {
            window.hfaDataLayer.push({ event: oi_event_name });
        }
    }
}

// Bind actions to Fancybox events
Fancybox.bind("[data-fancybox]", {
    on: {
        initCarousel: (fancybox) => {
            if(!fancyboxEventBlock) {
                // Block additional Fancybox events
                fancyboxEventBlock = true

                // Do Fancybox event
                doFancyboxOiEvent(fancybox)

                // Undo the event block after 1 second.
                setTimeout(() => {
                    fancyboxEventBlock = false
                }, 1000)
            }
        },
        done: (fancybox, slide) => {
            if(!fancyboxEventBlock) {
                // Do Fancybox event
                doFancyboxOiEvent(fancybox)
            }
        },
        destroy: () => {
            // Reset the block on Fancybox close.
            fancyboxEventBlock = false
        },
    },
});

/* END FANCYBOX */


// This fires the oi.utils function that will wrap all iframes contained in WYSIWYG
// editors with appropriate oi-aspect classes.

window.addEventListener('load', function () {
  oi.utils.wrap_oi_aspect();
}, false);


// Anchor Links
const links = document.querySelectorAll('.anchor-link');
const sections = document.querySelectorAll('.pagejump');

function changeLinkState() {
    let index = sections.length;
    if (index) {
        while (--index && window.scrollY + 80 < sections[index].offsetTop) { }
        links.forEach((link) => link.classList.remove('active'));
        if (links[index]) links[index].classList.add('active');
    }
}

changeLinkState();
window.addEventListener('scroll', changeLinkState);

// Add AOS
import AOS from 'aos';
AOS.init({
    disable: 'mobile',
    once: true,
});

// Fade background mega menu
const megaBtn = document.getElementById('megaBtn');
const fadedBg = document.getElementById('faded-background');

window.addEventListener('click', function onClick(event) {
    if (megaBtn.classList.contains('show')) {
        fadedBg.classList.add('show');
    } else {
        fadedBg.classList.remove('show');
    }
});

// Readmore
const readMoreLess = function () {
    var settings = {
        speed: 450,
        activeClass: 'is-active',
        selector: '[data-more]',
        selectorFooter: '[data-more-footer]',
        selectorTrigger: '[data-more-trigger]',
        selectorContent: '[data-more-content]',
    };
    var show = function (trigger, target, parent) {
        var getHeight = function () {
            var height = target.scrollHeight + 'px';
            return height;
        };
        var height = getHeight();
        parent.classList.add(settings.activeClass);
        target.style.height = height;
        var textLess = trigger.dataset.moreTextLess;
        trigger.textContent = textLess;
        window.setTimeout(function () {
            target.style.height = '';
        }, settings.speed);
    };
    var hide = function (trigger, target, parent) {
        var heightDefined = target.dataset.moreHeight;
        target.style.height = target.scrollHeight + 'px';
        parent.classList.remove(settings.activeClass);
        var textMore = trigger.dataset.moreTextMore;
        trigger.textContent = textMore;
        window.setTimeout(function () {
            target.style.height = heightDefined + 'px';
        }, 1);

    };
    var toggleContent = function (event, trigger) {
        var parent = event.target.closest(settings.selector),
            target = parent.querySelector(settings.selectorContent);
        if (parent.classList.contains(settings.activeClass)) {
            hide(trigger, target, parent);
            return;
        }
        show(trigger, target, parent);
    };
    var destroy = function (elem) {
        for (var i = 0; i < elem.length; i++) {
            var el = contentElements[i],
                height = el.scrollHeight,
                heightDefined = el.dataset.moreHeight,
                parent = el.closest(settings.selector),
                footer = parent.querySelector(settings.selectorFooter);

            if (height > 0 && height == heightDefined) {
                el.style.height = 'auto';
                footer.style.display = 'none';
            }
        }
    };
    var clickHandler = function (event) {
        var trigger = event.target.closest(settings.selectorTrigger);
        if (trigger) {
            event.preventDefault();
            toggleContent(event, trigger);
        }
    };
    document.addEventListener('click', clickHandler, false);
    var contentElements = document.querySelectorAll(settings.selectorContent);
    destroy(contentElements);
};
readMoreLess();
